module.exports = __webpack_public_path__ + "static/media/project.6c524423.svg";